import { gql } from '@apollo/client/core';

export const ADD_EMPLOYER = gql`
  mutation RequestCorporateUpgrade($workEmail: String!, $source: String!, $employerSlug: String, $employerName: String) {
    requestCorporateUpgrade(workEmail: $workEmail, source: $source, employerSlug: $employerSlug, employerName: $employerName) {
      ticketId
    }
  }
`;

export const CONSUME_CORPORATE_VERIFICATION_TOKEN = gql`
  mutation ConsumeCorporateVerificationToken($token: String!) {
    corp {
      consumeCorporateVerificationToken(token: $token) {
        success
        hadExistingPremium
      }
    }
  }
`;

export const GENERATE_CORPORATE_VERIFICATION_TOKEN = gql`
  mutation GenerateCorporateVerificationToken($employerSlug: String!, $workEmail: String!) {
    corp {
      generateCorporateVerificationToken(employerSlug: $employerSlug, workEmail: $workEmail) {
        success
      }
    }
  }
`;
